import { render, staticRenderFns } from "./MgmHome.vue?vue&type=template&id=1e2fc128&scoped=true&"
import script from "./MgmHome.vue?vue&type=script&lang=js&"
export * from "./MgmHome.vue?vue&type=script&lang=js&"
import style0 from "./MgmHome.vue?vue&type=style&index=0&id=1e2fc128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2fc128",
  null
  
)

export default component.exports